import { render, staticRenderFns } from "./editAddressPopup.vue?vue&type=template&id=5a564f56&scoped=true"
import script from "./editAddressPopup.vue?vue&type=script&lang=js"
export * from "./editAddressPopup.vue?vue&type=script&lang=js"
import style0 from "./editAddressPopup.vue?vue&type=style&index=0&id=5a564f56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a564f56",
  null
  
)

export default component.exports